import { render, staticRenderFns } from "./Kanit.vue?vue&type=template&id=3868dbf8&scoped=true"
import script from "./Kanit.vue?vue&type=script&lang=js"
export * from "./Kanit.vue?vue&type=script&lang=js"
import style0 from "./Kanit.vue?vue&type=style&index=0&id=3868dbf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868dbf8",
  null
  
)

export default component.exports